import React, { useEffect } from 'react'
import { MoneyHistoryList } from '../../../../../../views/widgets/moneyHistoryList'
import { useParams } from 'react-router-dom'
import { CCol, CRow, CSpinner } from '@coreui/react-pro'
import { useStore, useUnit } from 'effector-react'
import {
  $dividendBalanceByClient,
  dividendBalanceMounted,
} from '../../../../details/model'
import { getDividendBalance } from '../../../../../billing/deposits/edit/model'

export const NovaWallet = () => {
  const { clientID } = useParams()
  const dividendBalanceByClient = useStore($dividendBalanceByClient)
  const loading = useUnit(getDividendBalance.pending)

  useEffect(() => {
    dividendBalanceMounted()
  }, [])

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <CSpinner />
      </div>
    )
  }

  return (
    <div>
      <CRow>
        <CCol>
          <strong>Balance</strong>: {dividendBalanceByClient.balance}
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <strong>Currency</strong>: {dividendBalanceByClient.currency}
        </CCol>
      </CRow>
      {clientID && <MoneyHistoryList entityId={clientID} type="nova" />}
    </div>
  )
}
